<template>
  <v-list>
    <template v-for="(item, index) in items">
      <v-divider v-if="item.divider" :key="index"></v-divider>
      <v-list-item
        v-else
        :key="item.text"
        :to="item.to"
        :disabled="item.disabled"
        :inactive="item.disabled"
      >
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  name: "menu-master",

  data() {
    return {
      items: [
        {
          text: "Rodadas de Negócio",
          icon: "mdi-bullseye",
          to: "/rodadas",
          disabled: false,
        },
        {
          text: "Administradores",
          icon: "people",
          to: "/administradores",
          disabled: false,
        },
        {
          text: "Produtos",
          icon: "shopping_cart",
          to: "/produtos",
          disabled: false,
        },
        {
          text: "Clientes",
          icon: "group",
          to: "/clientes",
          disabled: false,
        },
        {
          text: "Fornecedores",
          icon: "people_outline",
          to: "/fornecedores",
          disabled: false,
        },
        {
          text: "Representantes",
          icon: "work",
          to: "/representantes",
          disabled: false,
        },
        {
          text: "Usuários",
          icon: "alternate_email",
          to: "/usuarios",
          disabled: false,
        },
        {
          text: "Notificações",
          icon: "notifications",
          to: "/notificacoes",
          disabled: false,
        },
        {
          text: "Banners",
          icon: "mdi-picture-in-picture-bottom-right",
          to: "/banners",
          disabled: false,
        },
        { divider: true },
        {
          text: "Relatórios",
          icon: "list_alt",
          to: "/relatorios-master",
          disabled: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
